import { checkSelectValidity, checkValidity } from './inputFields';

async function validateFields(
	elements,
	ev,
	isFormValid,
	validateToken,
	elementValues,
) {
	await elements.forEach(async (element) => {
		const isFieldValid = await checkValidity(element);

		let isSelectValid = true;
		if (element.tagName === 'SELECT') {
			isSelectValid = checkSelectValidity(element);
		}

		if (!isFieldValid || !isSelectValid) {
			ev.preventDefault();
		}
		if (isFieldValid === false || isSelectValid === false) {
			isFormValid = false;
		}

		if (
			validateToken &&
			(isFieldValid || isSelectValid || element.name === 'CRAFT_CSRF_TOKEN')
		) {
			if (element.type === 'checkbox') {
				elementValues[element.name] = element.checked;
			} else {
				elementValues[element.name] = element.value;
			}
		}
	});
	return isFormValid;
}

function validateCaptcha() {
	return grecaptcha?.getResponse();
}

export async function validateForm(
	ev,
	elements,
	validateToken,
	schouldValidateCaptcha,
) {
	let isFormValid = true;
	let elementValues = {};
	isFormValid = await validateFields(
		elements,
		ev,
		isFormValid,
		validateToken,
		elementValues,
	);

	if (schouldValidateCaptcha && isFormValid) {
		const captchaResponse = validateCaptcha();
		if (!captchaResponse?.length > 0) {
			return { isFormValid: false, elementValues };
		} else {
			elementValues['g-recaptcha-response'] = captchaResponse;
		}
	}
	return { isFormValid, elementValues };
}
